import axios from "axios";

//const API_BASE_URL = "http://a6de752220516488aae8f307f745715a-1051393800.ap-south-1.elb.amazonaws.com/stock_details";
const API_BASE_URL = "https://api.starmarketapi.online/stock_details";
const apiClient = axios.create({
  //baseURL: "http://a6de752220516488aae8f307f745715a-1051393800.ap-south-1.elb.amazonaws.com/stock_details", // Add your base URL here
  baseURL: "https://api.starmarketapi.online/stock_details",
  timeout: 15000, // Set a timeout if needed
  headers: {
    "Content-Type": "application/json",
  },
});
const FIREBASE_API_KEY = "AIzaSyClUDO4rvtOJsEIPiddWHvnDeszHXZf96A";
const FIREBASE_REFRESH_URL = `https://securetoken.googleapis.com/v1/token?key=${FIREBASE_API_KEY}`;
// Tokens state
let accessToken = null;
let refreshToken = null;

// Function to set tokens (call this after login)
export const setTokens = (newAccessToken, newRefreshToken) => {
  accessToken = newAccessToken;
  refreshToken = newRefreshToken;
};

// Add interceptors to handle request or response if needed
apiClient.interceptors.request.use(
  (config) => {
    accessToken = localStorage.getItem("accessToken");
    // Add authorization token or modify config if necessary
    if (accessToken) {
      config.headers = config.headers || {}; // Ensure headers object exists
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      console.log("after authorization");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    refreshToken = localStorage.getItem("refreshToken");

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        // Call Firebase's refresh token endpoint
        const refreshResponse = await axios.post(FIREBASE_REFRESH_URL, {
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        });

        accessToken = refreshResponse.data.id_token;
        refreshToken = refreshResponse.data.refresh_token;

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        // Update headers
        apiClient.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        console.log("Firebase token refreshed");

        return apiClient(originalRequest);
      } catch (refreshError) {
        console.error("Firebase token refresh failed:", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
